import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  show(message: string, options: {
    title?: string,
    type?: 'success' | 'error' | 'warning' | 'info',
    displayTime?: number
  } = {}) {
    const { title = '', type = 'success', displayTime = 5000 } = options;

    const notificationElement = document.createElement('div');

    // Eğer bir başlık verilmişse, başlığı ekle
    if (title) {
      const titleElement = document.createElement('strong');
      titleElement.innerText = title;
      notificationElement.appendChild(titleElement);
      notificationElement.appendChild(document.createElement('br')); // Başlık ve mesaj arasında boşluk
    
    }

    notificationElement.innerHTML += message.replace('\n', '<br/>'); // HTML içeriğini buraya yerleştiriyoruz

    notify({
      contentTemplate: () => notificationElement,
      width: 300,
      type: type,
      displayTime: displayTime,
    }, { position: 'bottom right', direction: 'right-stack'});
  }

  // showError Metodu
  showError(message: string, options: { title?: string, displayTime?: number } = {}) {
    this.show(message, { title: options.title, type: 'error', displayTime: options.displayTime });
  }

  
  showRight(message: string, options: {
    title?: string,
    type?: 'success' | 'error' | 'warning' | 'info',
    displayTime?: number
  } = {}) {
    const { title = '', type = 'success', displayTime = 5000 } = options;

    const notificationElement = document.createElement('div');

    // Eğer bir başlık verilmişse, başlığı ekle
    if (title) {
      const titleElement = document.createElement('strong');
      titleElement.innerText = title;
      notificationElement.appendChild(titleElement);
      notificationElement.appendChild(document.createElement('br')); // Başlık ve mesaj arasında boşluk
    
    }

    notificationElement.innerHTML += message.replace('\n', '<br/>'); // HTML içeriğini buraya yerleştiriyoruz

    notify({
      contentTemplate: () => notificationElement,
      width: 300,
      type: type,
      displayTime: displayTime,
    }, { position: 'bottom right', direction: 'right-stack'});
  }

  showLeft(message: string, options: {
    title?: string,
    type?: 'success' | 'error' | 'warning' | 'info',
    displayTime?: number
  } = {}) {
    const { title = '', type = 'success', displayTime = 5000 } = options;

    const notificationElement = document.createElement('div');

    // Eğer bir başlık verilmişse, başlığı ekle
    if (title) {
      const titleElement = document.createElement('strong');
      titleElement.innerText = title;
      notificationElement.appendChild(titleElement);
      notificationElement.appendChild(document.createElement('br')); // Başlık ve mesaj arasında boşluk
    
    }

    notificationElement.innerHTML += message.replace('\n', '<br/>'); // HTML içeriğini buraya yerleştiriyoruz

    notify({
      contentTemplate: () => notificationElement,
      width: 300,
      type: type,
      displayTime: displayTime,
    }, { position: 'bottom left', direction: 'right-stack'});
  }

  showCenter(message: string, options: {
    title?: string,
    type?: 'success' | 'error' | 'warning' | 'info',
    displayTime?: number
  } = {}) {
    const { title = '', type = 'success', displayTime = 5000 } = options;

    const notificationElement = document.createElement('div');

    // Eğer bir başlık verilmişse, başlığı ekle
    if (title) {
      const titleElement = document.createElement('strong');
      titleElement.innerText = title;
      notificationElement.appendChild(titleElement);
      notificationElement.appendChild(document.createElement('br')); // Başlık ve mesaj arasında boşluk
    
    }

    notificationElement.innerHTML += message.replace('\n', '<br/>'); // HTML içeriğini buraya yerleştiriyoruz

    notify({
      contentTemplate: () => notificationElement,
      width: 300,
      type: type,
      displayTime: displayTime,
    }, { position: 'center', direction: 'right-stack'});
  }
  
}
